export enum E_SUBJECT {
  OWNERSHIP_TYPES = "OWNERSHIP_TYPES",
  CASH_PAYMENT_CONTROL = "CASH_PAYMENT_CONTROL",
  ORGANIZATION_CONTROL = "ORGANIZATION_CONTROL",
  ACT = "ACT",
  ONLINE_APPEAL_STATUS = "ONLINE_APPEAL_STATUS",
  ROLES = "ROLES",
  TEMPLATES = "TEMPLATES",
  ACT_PACKS = "ACT_PACKS",
  REGIONS = "REGIONS",
  LEASING_DOCUMENT_TYPES = "LEASING_DOCUMENT_TYPES",
  ORGANIZATION = "ORGANIZATION",
  ORGANIZATION_PAYMENT_PACKS = "ORGANIZATION_PAYMENT_PACKS",
  CATEGORIES = "CATEGORIES",
  COURT_FILE_TYPES = "COURT_FILE_TYPES",
  COMPANY_SETTING_TYPES = "COMPANY_SETTING_TYPES",
  USERS = "USERS",
  COMPANY_ACT_CONTROL = "COMPANY_ACT_CONTROL",
  TRACKER_MODELS = "TRACKER_MODELS",
  POSITION_TYPES = "POSITION_TYPES",
  ONLINE_APPEALS = "ONLINE_APPEALS",
  ONLINE_APPEALS_REPORT = "ONLINE_APPEALS_REPORT",
  MFA_1_REPORTS = "MFA_1_REPORTS",
  HIGH_DEBT_SVOD = "HIGH_DEBT_SVOD",
  MUNIS_PAYMENTS_REPORT = "MUNIS_PAYMENTS_REPORT",
  ELECTRONIC_PAYMENTS_REPORT = "ELECTRONIC_PAYMENTS_REPORT",
  RESIDENTS_WITH_HIGH_INDEBTEDNESS_REPORT = "RESIDENTS_WITH_HIGH_INDEBTEDNESS_REPORT",
  LEASING_CONFIGURATIONS = "LEASING_CONFIGURATIONS",
  COMPANY = "COMPANY",
  COMPANY_LOGIN = "COMPANY_LOGIN",
  EMPLOYEES = "EMPLOYEES",
  ACT_TYPES = "ACT_TYPES",
  LEASING = "LEASING",
  TARIFFS = "TARIFFS",
  MYGOVTASK = "MYGOVTASK",
  COURT_PROCESS_ANALYSIS = "COURT_PROCESS_ANALYSIS",
  ORGANIZATION_PAYMENTS = "ORGANIZATION_PAYMENTS",
  PNFL_AND_CADASTRE = "PNFL_AND_CADASTRE",
  AUDITS = "AUDITS",
  COMPANY_NOTIFICATION = "COMPANY_NOTIFICATION",
  ELECTRICITY = "ELECTRICITY",
  BLOCKED_USERS = "BLOCKED_USERS",
  RESIDENTS = "RESIDENTS",
  HET_BLOCK_RESIDENT = "HET_BLOCK_RESIDENT",
  DELETED_RESIDENTS = "DELETED_RESIDENTS",
  HET_SEND_SMS_WARNING = "HET_SEND_SMS_WARNING",
  ORGANIZATION_EMPLOYEE = "ORGANIZATION_EMPLOYEE",
  LITIGATION_STATUSES = "LITIGATION_STATUSES",
  COMPANY_SETTINGS = "COMPANY_SETTINGS",
  ORGANIZATION_DEPARTMENT = "ORGANIZATION_DEPARTMENT",
  COURT_WARNINGS = "COURT_WARNINGS",
  LEASING_PAYMENT = "LEASING_PAYMENT",
  NOTIFICATION_TYPES = "NOTIFICATION_TYPES",
  CENTER_EMPLOYEES = "CENTER_EMPLOYEES",
  ORGANIZATION_TYPES = "ORGANIZATION_TYPES",
  FROZEN_STREETS = "FROZEN_STREETS",
  GEODATA = "GEODATA",
  ACT_STATUSES = "ACT_STATUSES",
  CASH_PAYMENT = "CASH_PAYMENT",
  PACK_TYPES = "PACK_TYPES",
  GPS_GEOGRAPHY_VILLAGES_CLASSIFIER = "GPS_GEOGRAPHY_VILLAGES_CLASSIFIER",
  AUTOMOBILE_TYPES = "AUTOMOBILE_TYPES",
  LEASING_PROCESS = "LEASING_PROCESS",
  NOTIFICATION_TEMPLATES = "NOTIFICATION_TEMPLATES",
  SMS_TEMPLATES = "SMS_TEMPLATES",
  INDUSTRY_TYPES = "INDUSTRY_TYPES",
  ACT_ACTION_TYPES = "ACT_ACTION_TYPES",
  CASH_PAYMENT_PACKS = "CASH_PAYMENT_PACKS",
  TRANSACTIONS = "TRANSACTIONS",
  COMPANIES = "COMPANIES",
  POLYGONS = "POLYGONS",
  POLYGON_TARIFFS = "POLYGON_TARIFFS",
  POLYGON_LICENSED_ORGANIZATION = "POLYGON_LICENSED_ORGANIZATION",
  POLYGON_EMPLOYEE = "POLYGON_EMPLOYEE",
  POLYGON_VISIT_REGISTER = "POLYGON_VISIT_REGISTER",
  POLYGON_AUTOMOBILE = "POLYGON_AUTOMOBILE",
  LEASING_TRANSPORT = "LEASING_TRANSPORT",
  AUTOMOBILES = "AUTOMOBILES",
  ONLINE_APPEAL_TYPES = "ONLINE_APPEAL_TYPES",
  STREETS = "STREETS",
  DISTRICTS = "DISTRICTS",
  MAHALLA = "MAHALLA",
  SUB_MAHALLAS = "SUB_MAHALLAS",
  SUB_MAHALLA_RESIDENTS = "SUB_MAHALLA_RESIDENTS",
  SUB_MAHALLA_POINTS = "SUB_MAHALLA_POINTS",
  USERS_OWN_PASSWORD = "USERS_OWN_PASSWORD",
  INDIVIDUAL_RESIDENTS = "INDIVIDUAL_RESIDENTS",
  MUNIS_PAYMENT = "MUNIS_PAYMENT",
  PERIOD_OPERATIONS = "PERIOD_OPERATIONS",
  COMPANY_PERIOD_OPERATIONS = "COMPANY_PERIOD_OPERATIONS",
  REPORTING_PERIOD = "REPORTING_PERIOD",
  PAYMENT_PARTNERS = "PAYMENT_PARTNERS",
  RESIDENT_CONTRACT_TEMPLATES = "RESIDENT_CONTRACT_TEMPLATES",
  REPORTS = "REPORTS",
  F2_DHJ = "F2_DHJ",
  DHJ1 = "DHJ1",
  PAYMENT_PARTNER_TRANSACTIONS = "PAYMENT_PARTNER_TRANSACTIONS",
  DHJ2_REVENUES = "DHJ2_REVENUES",
  DHJ_REVENUES = "DHJ_REVENUES",
  MAHALLA_DEBITORS = "MAHALLA_DEBITORS",
  MAHALLA_CREDITORS = "MAHALLA_CREDITORS",
  UNPAID_RESIDENTS = "UNPAID_RESIDENTS",
  HIGH_DEBT = "HIGH_DEBT",
  COMPANY_NOTIFICATIONS = "COMPANY_NOTIFICATIONS",
  COURT_PERIODICAL_REPORT = "COURT_PERIODICAL_REPORT",
  NOTIFICATION = "NOTIFICATION",
  NOTIFICATION_REQUIREMENTS = "NOTIFICATION_REQUIREMENTS",
  COMPANY_AUTOMOBILES = "COMPANY_AUTOMOBILES",
  WIALON = "WIALON",
  CITIZEN = "CITIZEN",
  HISTORY_SEND_MESSAGE = "HISTORY_SEND_MESSAGE",
  COMPANY_BLOCK_MENU_ITEM = "COMPANY_BLOCK_MENU_ITEM",
  HOUSES = "HOUSES",
  INSPECTOR = "INSPECTOR",
  MOBILE = "MOBILE",
  LEGAL_RESIDENT_CONTRACTS = "LEGAL_RESIDENT_CONTRACTS",
  ADDITIONAL_SERVICE_TYPES = "ADDITIONAL_SERVICE_TYPES",
  LEGAL_RESIDENTS_NORMS = "LEGAL_RESIDENTS_NORMS",
  LEGAL_RESIDENTS = "LEGAL_RESIDENTS",
  LEGAL_RESIDENTS_TARIFFS = "LEGAL_RESIDENTS_TARIFFS",
  DASHBOARD = "DASHBOARD",
  GEO_DASHBOARD = "GEO_DASHBOARD",
  FIRTS_INVENTORY_ACTS = "FIRTS_INVENTORY_ACTS",
  NOTIFICATION_RESTRICTIONS = "NOTIFICATION_RESTRICTIONS",
  POLYGON = "POLYGON",
  FROZEN_MAHALLA = "FROZEN_MAHALLA",
  FROZEN_RESIDENT = "FROZEN_RESIDENT",
  "LEGAL-RESIDENT" = "LEGAL-RESIDENTS",
  "UNPAID-RESIDENTS" = "UNPAID-RESIDENTS",
  "ADDITIONAL-SERVICE-TYPES" = "ADDITIONAL-SERVICE-TYPES",
  "LEGAL-RESIDENT-CONTRACTS" = "LEGAL-RESIDENT-CONTRACTS",
  "1031_PAYMENTS" = "1031_PAYMENTS",
  DXSH_INVESTMENT_CATEGORY = "DXSH_INVESTMENT_CATEGORY",
  DXSH_INVESTMENT_OBLIGATION = "DXSH_INVESTMENT_OBLIGATION",
  DXSH_INVESTMENT_CONTRACT = "DXSH_INVESTMENT_CONTRACT",
  DXSH_MODUL_REPORT = "DXSH_MODUL_REPORT",
  POLYGON_LICENSED_ORGANIZATION_AUTOS = "POLYGON_LICENSED_ORGANIZATION_AUTOS",
  VILLAGES_CLASSIFIER = "VILLAGES_CLASSIFIER",
  MANAGEMENT_DAILY_INCOMES = "MANAGEMENT_DAILY_INCOMES",
  MYGOVTASK_REPORT = "MYGOVTASK_REPORT",
  GNK_RESIDENT_REPORT = "GNK_RESIDENT_REPORT",
  MUNIS_BETWEEN_PERIOD_REPORT = "MUNIS_BETWEEN_PERIOD_REPORT",
  COMPANY_SEND_SMS_DEBITORS = "COMPANIES_SEND_SMS_DEBIT_RESIDENT",
  MFA_2_REPORTS = "MFA_2_REPORTS",
  MFA16_REPORTS = "MFA16_REPORTS",
  ACT_REPORT = "ACT_REPORT",
  WASTE_COLLECTION_AREA = "WASTE_COLLECTION_AREA",
  COM_GR_ADMIN = "COMPANY_GROUP_ADMINS",
  COMPANY_CONTRACT = "COMPANY_CONTRACT",
  COMPANY_FILES = "COMPANY_FILES",
  COMPANY_EMPLOYEES = "COMPANY_EMPLOYEES",
  RESIDENT_WASTE_COLLECTIONS = "RESIDENT_WASTE_COLLECTIONS",
  MFA8_REPORTS = "MFA8_REPORTS",
  IDENTIFIED_RESIDENT_REPORT = "IDENTIFIED_RESIDENT_REPORT",
  ANALYTICAL_SMS_REPORTS = "ANALYTICAL_SMS_REPORTS",
  SMS_SUMMARY_REPORTS = "SMS_SUMMARY_REPORTS",
  RESIDENT_MONITORING = "RESIDENT_MONITORING",
  ACT_STATUS_REPORTS = "ACT_STATUS_REPORTS",
  RESIDENT_CHANGE_REPORT = "RESIDENT_CHANGE_REPORT",
  F3DHJ_REPORTS = "F3DHJ_REPORTS",
  INCORRECT_RESIDENTS_DATA = "INCORRECT_RESIDENTS_DATA",
  COURTWARNING_REPORT = "COURTWARNING_REPORT",
  MFA6_REPORTS = "MFA6_REPORTS",
  REVENUES_BY_EMPLOYEES = "REVENUES_BY_EMPLOYEES",
  MAHALLA_VISIT_SUMMARY = "MAHALLA_VISIT_SUMMARY",
  GNK_RESIDENTS = "GNK_RESIDENTS",
  LICENSED_ORGANIZATION_CONTRACT = "LICENSED_ORGANIZATION_CONTRACT",
  MANUAL_CANCEL_TRANSACTION = "MANUAL_CANCEL_TRANSACTION",
  DEBT_SETTLEMENT_REPORT = "DEBT_SETTLEMENT_REPORT",
  SUB_ACCOUNT_ATTACHMENT = "SUB_ACCOUNT_ATTACHMENT",
  VISIT_GRAPH_FILE = "VISIT_GRAPH_FILE",
  BANK_BILLING_COMPARISON = "BANK_BILLING_DIFFERENCE",
  MIA_INHABITANT = "MIA_INHABITANT",
  VISITS_GRAPH_CONTROL = "VISITS_GRAPH_CONTROL",
  GPS_VISITS_GRAPH = "GPS_VISITS_GRAPH",
  DUPLICATE_CADASTRAL = "DUPLICATE_CADASTRAL",
  SHARED_AUTOMOBILES = "SHARED_AUTOMOBILES",
  MAHALLA_SEND_SMS_WARING = "MAHALLA_SEND_SMS_WARING",
  DAILY_RESIDENTS = "DAILY_RESIDENTS",
  ACT_PACK_REPORT = "ACT_PACK_REPORT",
  HET_BLOCK_RESIDENTS_REPORT = "HET_BLOCK_REPORT",
  HET_WARNING_RESIDENTS_REPORT = "HET_WARNING_REPORT",
  HET_WARNING_POSSIBLE_RESIDENTS_REPORT = "HET_WARNING_POSSIBLE_REPORT",
  RESIDENT_IDENTIFICATION_CANCEL_REASON = "RESIDENT_IDENTIFICATION_CANCEL_REASON",
  RESIDENT_FEEDBACK = "RESIDENT_FEEDBACK",
  PINFL_CADASTRAL_NUMBER = "PINFL_CADASTRAL_NUMBER",
  MAHALLA_CONTRACT = "MAHALLA_CONTRACT",
  HET_WARNING_MAHALLAS = "HET_WARNING_MAHALLAS",
  MAHALLA_CONTRACT_REPORT = "MAHALLA_CONTRACT_REPORT",
  RESIDENT_COVERED_AREA_REPORT = "RESIDENT_COVERED_AREA_REPORT",
  CADASTRE_PUSH = "CADASTRE_PUSH",
  MAHALLA_AUTOMATIC_SEND_HET_WARNING = "MAHALLA_AUTOMATIC_SEND_HET_WARNING",
  MAHALLA_SEND_HET_WARNING = "MAHALLA_SEND_HET_WARNING",
}

export enum E_ACTIONS {
  SYNC = "SYNC",
  READ = "READ",
  CREATE = "CREATE",
  DELETE = "DELETE",
  UPDATE = "UPDATE",
  CHANGE_STATUS = "CHANGE_STATUS",
  EXPORT_EXCEL = "EXPORT_EXCEL",
  ONLINE_APPEAL_RESIDENT = "ONLINE_APPEAL_RESIDENT",
  ACCEPT = "ACCEPT",
  IMPORT_EXCEL = "IMPORT_EXCEL",
  PATCH = "PATCH",
  VIEW = "VIEW",
  ANSWER = "ANSWER",
  PATCH_INHABITANTS_COUNT = "PATCH_INHABITANTS_COUNT",
  WATCH_AUTOMOBILE = "WATCH_AUTOMOBILE",
  CADASTR_SEARCH = "CADASTR_SEARCH",
  CHECK_REGISTERED_INHABITANTS = "CHECK_REGISTERED_INHABITANTS",
  SEARCH_FROM_CADASTRE = "SEARCH_FROM_CADASTRE",
  FIRST_INVENTORY = "FIRST_INVENTORY",
  PATCH_ENERGY_INFO = "PATCH_ENERGY_INFO",
  IMPORT_OF_PRIMARY_INVENTORY = "IMPORT_OF_PRIMARY_INVENTORY",
  IMPORT_NSALDO = "IMPORT_NSALDO",
  EDIT_BY_IMPORT = "EDIT_BY_IMPORT",
  CREATE_BY_IMPORT = "CREATE_BY_IMPORT",
  PRINT_CONTRACT = "PRINT_CONTRACT",
  PRINT_CARD = "PRINT_CARD",
  VIEW_CARD = "VIEW_CARD",
  RUN = "RUN",
  UPDATE_OWN_PASSWORD = "UPDATE_OWN_PASSWORD",
  UNBLOCK = "UNBLOCK",
  GET_REFERENCE = "GET_REFERENCE",
  CHANGE_CONTRACT_STATUS = "CHANGE_CONTRACT_STATUS",
  "PRINT-ALL" = "PRINT-ALL",
  "BATCH-EDIT-UCHASTOK" = "BATCH-EDIT-UCHASTOK",
  "BATCH-EDIT-STREET" = "BATCH-EDIT-STREET",
  "CANCEL-CONTRACT" = "CANCEL-CONTRACT",
  ATTACH_POLYGON = "ATTACH_POLYGON",
  REPORT = "REPORT",
  MAHALLA_VISIT_SUMMARY = "MAHALLA_VISIT_SUMMARY",
  UPDATE_SERVICED_STATUS = "UPDATE_SERVICED_STATUS",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  CONFIRM = "CONFIRM",
  GPS_FIELDS = "GPS_FIELDS",
  VISITS_COUNT = "VISITS_COUNT",
}

export enum E_MENU {
  ORGANIZATIONS_LIST_1031 = "ORGANIZATIONS_LIST_1031",
  CASH_PAYMENT_CONTROL = "CASH_PAYMENT_CONTROL",
  ORGANIZATION_CONTROL = "ORGANIZATION_CONTROL",
  PAYMENTS_LIST_1031 = "PAYMENTS_LIST_1031",
  PHYSICAL_STATS = "PHYSICAL_STATS",
  ACTS = "ACTS",
  CATALOG_COMPANY_SETTINGS_TYPES = "CATALOG_COMPANY_SETTINGS_TYPES",
  MYGOVTASK = "MYGOVTASK",
  CATALOG_NOTIFICATION_TYPES = "CATALOG_NOTIFICATION_TYPES",
  CATALOG_PAYMENT_PARTNERS = "CATALOG_PAYMENT_PARTNERS",
  CATALOG_STATUSES_AND_TYPES = "CATALOG_STATUSES_AND_TYPES",
  CATALOG_TEMPLATE_TYPES_CERTIFICATE = "CATALOG_TEMPLATE_TYPES_CERTIFICATE",
  CATALOG_TEMPLATE_TYPES_CONTRACT = "CATALOG_TEMPLATE_TYPES_CONTRACT",
  CATALOG_TEMPLATE_TYPES_NOTIFICATION = "CATALOG_TEMPLATE_TYPES_NOTIFICATION",
  CATALOG_TEMPLATE_TYPES_SMS = "CATALOG_TEMPLATE_TYPES_SMS",
  COMPANY_EMPLOYEES = "COMPANY_EMPLOYEES",
  COMPANY_ACT_CONTROL = "COMPANY_ACT_CONTROL",
  COMPANY_LIST = "COMPANY_LIST",
  COURT_PROCEEDINGS = "COURT_PROCEEDINGS",
  COURT_WARNINGS = "COURT_WARNINGS",
  DXSH_CATEGORIES = "DXSH_CATEGORIES",
  DXSH_COMPANIES = "DXSH_COMPANIES",
  DXSH_REPORTS = "DXSH_REPORTS",
  DXSH_STATISTICS = "DXSH_STATISTICS",
  FIRST_INVENTORY_ACTS = "FIRST_INVENTORY_ACTS",
  FROZEN_DEBT_ACTS = "FROZEN_DEBT_ACTS",
  FROZEN_VILLAGES = "FROZEN_VILLAGES",
  GEO_ANALYSIS = "GEO_ANALYSIS",
  SMS_GATEWAY = "SMS_GATEWAY",
  GPS_CATALOGS_AUTOMOBILES = "GPS_CATALOGS_AUTOMOBILES",
  VISITS_GRAPH_CONTROL = "VISITS_GRAPH_CONTROL",
  GEO_OBJECT_RESIDENT_BIND = "GEO_OBJECT_RESIDENT_BIND",
  GPS_CATALOGS_AUTOMOBILE_TYPES = "GPS_CATALOGS_AUTOMOBILE_TYPES",
  GPS_CATALOGS_GPS_DEVICE_MODELS = "GPS_CATALOGS_GPS_DEVICE_MODELS",
  GPS_GEOGRAPHY_DISTRICTS = "GPS_GEOGRAPHY_DISTRICTS",
  GPS_GEOGRAPHY_REGIONS = "GPS_GEOGRAPHY_REGIONS",
  VILLAGES_CLASSIFIER = "GPS_GEOGRAPHY_VILLAGES_CLASSIFIER",
  GPS_GEOGRAPHY_STREETS = "GPS_GEOGRAPHY_STREETS",
  GPS_GEOGRAPHY_VILLAGES = "GPS_GEOGRAPHY_VILLAGES",
  GPS_GEOGRAPHY_WASTE_COLLECTION_AREAS = "GPS_GEOGRAPHY_WASTE_COLLECTION_AREAS",
  GPS_LEGAL_RESIDENTS = "GPS_LEGAL_RESIDENTS",
  GPS_MONITORING = "GPS_MONITORING",
  GPS_REPORTS_EQUIPMENT_ENTRY_EXIT_TIMES = "GPS_REPORTS_EQUIPMENT_ENTRY_EXIT_TIMES",
  GPS_VISITS_GRAPH_ANALYZE = "GPS_VISITS_GRAPH_ANALYZE",
  GPS_REPORTS_WORKING_TIME = "GPS_REPORTS_WORKING_TIME",
  GPS_REPORTS_EQUIPMENT_LEGAL_RESIDENTS_VISITS = "GPS_REPORTS_EQUIPMENT_LEGAL_RESIDENTS_VISITS",
  RESIDENT_VISITS_ACCRUALS_REPORT = "RESIDENT_VISITS_ACCRUALS_REPORT",
  GPS_REPORTS_POLYGON_VISITS = "GPS_REPORTS_POLYGON_VISITS",
  GPS_STATISTICS = "GPS_STATISTICS",
  LEASING_DOCUMENT_TYPES = "LEASING_DOCUMENT_TYPES",
  LEASING_EQUIPMENT_AND_TOOLS = "LEASING_EQUIPMENT_AND_TOOLS",
  LEASING_PROCESSES = "LEASING_PROCESSES",
  LEASING_SETTINGS = "LEASING_SETTINGS",
  LEASING_STATISTICS = "LEASING_STATISTICS",
  LEGAL_RESIDENTS = "LEGAL_RESIDENTS",
  LEGAL_RESIDENT_ADDITIONAL_SERVICE_TYPES = "LEGAL_RESIDENT_ADDITIONAL_SERVICE_TYPES",
  LEGAL_RESIDENT_NORMATIVES = "LEGAL_RESIDENT_NORMATIVES",
  LEGAL_RESIDENT_INDUSTRY_TYPES = "LEGAL_RESIDENT_INDUSTRY_TYPES",
  LEGAL_RESIDENT_STATISTICS = "LEGAL_RESIDENT_STATISTICS",
  LEGAL_RESIDENT_TARIFFS = "LEGAL_RESIDENT_TARIFFS",
  MAIN_DASHBOARD = "MAIN_DASHBOARD",
  NOTIFICATION_RESTRICTIONS = "NOTIFICATION_RESTRICTIONS",
  ONLINE_APPEALS = "ONLINE_APPEALS",
  PAYMENTS_CASH = "PAYMENTS_CASH",
  PAYMENTS_ELECTRONIC = "PAYMENTS_ELECTRONIC",
  PAYMENTS_MUNIS = "PAYMENTS_MUNIS",
  PERIOD_OPERATIONS = "PERIOD_OPERATIONS",
  POLIGON_COMPANIES = "POLIGON_COMPANIES",
  POLIGON_INFORMATION = "POLIGON_INFORMATION",
  POLIGON_LICENSED_ORGANIZATIONS = "POLIGON_LICENSED_ORGANIZATIONS",
  POLIGON_STATISTICS = "POLIGON_STATISTICS",
  HET_BLOCK_RESIDENT = "HET_BLOCK_RESIDENT",
  DELETED_RESIDENTS = "DELETED_RESIDENTS",
  POLIGON_TARIFFS = "POLIGON_TARIFFS",
  POLIGON_REPORT_VISITS = "POLIGON_REPORT_VISITS",
  POLYGON_EMPLOYEE = "POLYGON_EMPLOYEE",
  REPORTS = "REPORTS",
  RESIDENTS = "RESIDENTS",
  CHANGE_PHONE_REQUEST = "CHANGE_PHONE_REQUEST",
  GNK_RESIDENTS = "GNK_RESIDENTS",
  EMPLOYEE_ACTIONS = "EMPLOYEE_ACTIONS",
  RESIDENT_ACTIONS = "RESIDENT_ACTIONS",
  TARIFF = "TARIFF",
  USERS_BLOCKED_USERS = "USERS_BLOCKED_USERS",
  USERS_LIST = "USERS_LIST",
  USERS_ROLES = "USERS_ROLES",
  SYSTEM_CONFIGURATION = "SYSTEM_CONFIGURATION",
  MYGOVTASK_REPORT = "MYGOVTASK_REPORT",
  MANAGEMENT_DAILY_INCOMES = "MANAGEMENT_DAILY_INCOMES",
  FROZEN_RESIDENTS = "FROZEN_RESIDENT",
  FROZEN_STREETS = "FROZEN_STREETS",
  GPS_VISITS_GRAPH = "GPS_VISITS_GRAPH",
  MUNIS_SVERKA = "MUNIS_RECONCILIATION",
  GNK_RESIDENT_REPORT = "GNK_RESIDENT_REPORT",
  COM_GR_ADMIN = "COMPANY_GROUP_ADMINS",
  MAHALLA_VISIT_SUMMARY = "MAHALLA_VISIT_SUMMARY",
  COMPANY_LOGIN = "COMPANY_LOGIN",
  SUB_MAHALLAS = "SUB_MAHALLAS",
  MIA_INHABITANT = "MIA_INHABITANT",
  GEO_OBJECT_RESIDENT_BIND_REPORT = "GEO_OBJECT_RESIDENT_BIND_REPORT",
  CADASTRE_PUSH = "CADASTRE_PUSH",
  INCORRECT_RESIDENTS_DATA = "INCORRECT_RESIDENTS_DATA",
}
